<template>
    <div class="designer-container">
      <div class="active">
        <div>凡在设计单位、咨询公司、建筑智能化系统集成企业及相关单位中从事建筑智能化工程设计工作的优秀咨询设计人 员均可报名参选，如设计师、技术工程师、方案经理、技 术经理、技术总监等</div>
        <div class="active-img">
          <img src="../../assets/images/activities/active-img1.jpg" alt="">
          <img src="../../assets/images/activities/active-img2.jpg" alt="">
        </div>
      </div>
      <div class="rewards"></div>
      <div class="Pc_url">
        <img src="../../assets/images/activities/bm.jpg" alt="">
        <p>请登河姆渡PC端优秀设计师报名入口：</p>
        <a>https://solution.homedo.com/</a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'designer-2020',
  data () {
    return {

    }
  },
  mounted () {
    if (new Date().getTime() > new Date('2020-06-01').getTime()) {
      window.location.href = 'https://www.homedo.com/actm/201905091027155049.shtml'
      return
    }
    let livePageUrl = 'https://www.homedo.com/actm/2020051317417194.shtml'
    const host = window.location.host
    if (host === 'msolution.fat.homedo.com') {
      livePageUrl = 'https://www.fat.homedo.com/actm/202005131816214259.shtml'
    }
    window.location.href = livePageUrl
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.designer-container {
  &, * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  width: 100%;
  height: 35rem;
  padding-top: 12.346rem;
  padding-bottom: 4.2666rem;
  background: #0325C4 url("../../assets/images/activities/bg.jpg") no-repeat top;
  background-size: contain;

  .active {
    margin: auto;
    width: 9.2rem;
    padding: 1.6rem 0.4rem 0.333333rem;
    background: #ffffff url("../../assets/images/activities/activity-bg.jpg") no-repeat top;
    background-size: contain;

    font-size: .32rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.5333rem;
    letter-spacing: 0px;
    color: #000000;

    .active-img {
      margin-top: 0.2666666rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      img {
        width: 3.9466rem;
        height: 2.5333rem;
      }
    }
  }

  .rewards {
    margin: .4533rem auto 0;
    width: 9.2rem;
    height: 11.3066rem;
    padding-top: 1.7333rem;
    background: #ffffff url("../../assets/images/activities/rewards-bg.jpg") no-repeat top;
    background-size: contain;
  }

  .Pc_url {
    margin-top: 1rem;
    text-align: center;
    font-size: 0.32rem;
    line-height: 0.666666rem;
    letter-spacing: 0px;
    color: #ffffff;

    img {
      width: 119px;
      height: 30px;
    }

    a {
      color: #04edff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/activities/2020-designer.vue